import { Typography } from "src/latest/src/components";

interface PolicyHolderTodoHeaderProps {
  userFullName: string;
}

interface IdentificationCardTodoHeaderProps {
  userFullName: string;
  ehrName: string;
}

interface CreditCardTodoHeaderProps {
  userFullName: string;
}

interface HighAcuityTodoHeaderProps {
  userFullName: string;
  metadata: Record<string, any>;
}

export const PolicyHolderTodoHeader: React.FC<PolicyHolderTodoHeaderProps> = ({
  userFullName,
}) => {
  return (
    <div className="mb-4">
      <span style={{ fontWeight: 'bold' }}>{userFullName}</span> did not enter
      all the <br /> information during their intake. This information will need{' '}
      <br /> to be collected and entered into AdvanceMD. Please <br /> contact
      the client to remind them that you need this missing <br /> information in
      order to verify their insurance and get them <br /> matched with a
      therapist.
    </div>
  );
};

export const IdentificationCardTodoHeader: React.FC<
  IdentificationCardTodoHeaderProps
> = ({ userFullName, ehrName }) => {
  return (
    <div className="mb-4">
      <span style={{ fontWeight: 'bold' }}>{userFullName}</span> did not provide
      their ID during intake. <br /> ID document will need to be collected and
      entered into {ehrName}. Please contact the client to remind them that you
      need their ID to confirm their requested appointment.
      <br />
    </div>
  );
};

export const CreditCardTodoHeader: React.FC<CreditCardTodoHeaderProps> = ({
  userFullName,
}) => {
  return (
    <div className="mb-4">
      <span style={{ fontWeight: 'bold' }}>{userFullName}</span> did not enter
      all the required credit card <br />
      and responsible party information during their intake. This <br />{' '}
      information will need to be collected and entered into AdvanceMD.
      <br /> Please contact the client to remind them that you need <br /> this
      missing information in order to Schedule their intake
      <br />
      appointment and get them matched with a therapist.
    </div>
  );
};

export const HighAcuityTodoHeader: React.FC<HighAcuityTodoHeaderProps> = ({
  userFullName,
  metadata,
}) => {
  return (
    <div className="mb-4">
      <Typography variant="size-16" color="color-2">
        {' '}
        <span style={{ fontWeight: 'bold' }}>{userFullName}</span> endorsed the
        following responses:
      </Typography>{' '}
      <Typography
        variant="size-14"
        color="color-2"
        weight="bold"
        className="mt-4 mb-3"
      >
        {' '}
        {metadata?.['selected-choice-titles']?.map((selectedOption: any) => {
          return (
            <>
              {selectedOption}
              <br />
              <br />
            </>
          );
        })}
      </Typography>{' '}
    </div>
  );
};

export const CreditCardCollectionText: React.FC = () => {
  return (
    <Typography>
      Were you able to collect all the required credit card and responsible
      party information?
    </Typography>
  );
};

export const PolicyHolderCollectionText: React.FC = () => {
  return (
    <Typography>
      Were you able to collect all the necessary insurance information required?
    </Typography>
  );
};

export const IdentificationCardCollectionText: React.FC = () => {
  return <Typography>Were you able to collect ID?</Typography>;
};
